import React, { useEffect, useRef, useState } from "react";
import { useTheme } from "@material-ui/core/styles";
//import { AppBar, Tab, Tabs, Typography } from '@material-ui/core';
import { useDispatch, useSelector } from "react-redux";
import { getJCJPIDs } from "../../../../utils/common";
import { triggerFetchSalesTable } from "../../../../redux/actions";
import PrimarySalesView from "../../../../views/deviceSales/sales/component/PrimarySalesView";

const PrimarySales = (props) => {
  const dispatch = useDispatch();
  //const classes = useStyles();
  const theme = useTheme();

  const { url } = props;
  const filterData = props.filterValue;
  const { salesObj, headerUnit, salesCsvLoading } = useSelector(
    (state) => state.homeReducer
  );
  const [mainValue, setMainValue] = useState(0);
  //const [selectedTab, setSelectedTab] = React.useState(0);
  const PreviousValue = (value) => {
    const ref = useRef();
    useEffect(() => {
      ref.current = value;
    });
    return ref.current;
  };

  let { level, jioPointId, partnerRT, partnerType, retailerId } =
    getJCJPIDs(filterData);
  const body = {
    id: filterData.selectedRole
      ? filterData.selectedRole.split(" - ")[2]
      : filterData.orgId,
    partnerRoleType: partnerRT, //filterData.selectedPartnerRoleName,
    fromDate: props.startDate,
    toDate: props.endDate,
    section: props.section,
    dispValue: headerUnit.unit,
    moduleName: props.moduleName,
    jprTypeName:
      filterData.selectedCategory && filterData.selectedCategory !== "ALL"
        ? filterData.selectedCategory
        : "",
    level,
    jioPointId,
    partnerType,
    retailerId,
  };

  const pV = PreviousValue(filterData);

  useEffect(() => {
    const controller = new AbortController();

    function fetchData() {
      const obj = {
        headers: {
          "Content-Type": "application/json",
          url: url,
        },
        params: body,
        extraData: url,
      };

      return dispatch(triggerFetchSalesTable(obj, controller.signal));
    }
    if (salesObj && salesObj.salesTableData[url] === undefined) {
      fetchData();
    }
    if (
      pV &&
      pV.selectedCategory !== filterData &&
      filterData.selectedCategory
    ) {
      fetchData();
    }

    // Cleanup function to cancel the request if the component unmounts
    return () => {
      controller.abort(); // Cancels the request when the component unmounts
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    props.data,
    props.startDate,
    props.endDate,
    headerUnit,
    filterData.selectedCategory,
  ]);

  const mainHandleChange = (event, newMainValue) => {
    setMainValue(newMainValue);
  };
  // const handleChange = (event, newValue) => {
  //     setSelectedTab(event);
  // };

  const endpointData = salesObj && salesObj.salesTableData;
  const data = endpointData && endpointData[url] && endpointData[url][0];
  // data && console.log("DATA FROM SALES OBJ ------>>>> ", Object.entries(data?.salesWrapper));

  // modify data as per requirements
  const modifiedData =
    data &&
    Object.entries(data?.salesWrapper)
      .filter((item) => item[0] !== "LYF")
      .map((item) => {
        item[0] = item[0].toUpperCase();
        return item;
      });

  let updatedData = [];
  const sortingOrder = window.ORDER_OF_SALES_TILES;
  sortingOrder.map(row => {
    modifiedData &&
    modifiedData.find((item) => item[0] === row) &&
    updatedData.push(modifiedData.find((item) => item[0] === row));
  })

  // console.log("updatedData ===========> ", updatedData, modifiedData,salesObj,data);

  return (
    <PrimarySalesView
      filterData={props.filterValue}
      mainHandleChange={mainHandleChange}
      mainValue={mainValue}
      salesObj={salesObj}
      salesCsvLoading={salesCsvLoading}
      isCsvActive={props.isCsvActive}
      data={props.data}
      headerUnit={headerUnit}
      theme={theme}
      body={body}
      updatedData={updatedData}
      csvUrl={props.csvUrl}
      tileName={props.tileName}
      dashboardName={props.moduleName}
      viewName={props.viewName}
    />
  );
};

export default PrimarySales;
